import { request } from '@/api/common'
import apis from '@/common/config/host'
const Topic = apis.cApiDomain + '/feed/topicIndexV4'
// const Topic = apis.cApiDomain + '/feed/specialTopicIndex'
export const getTopic = function (params) {
  return request.post(Topic, params)
}
